import { emptyObj } from 'util/objects'

export const selectApplication = (state = emptyObj) => state.app || emptyObj
